import React from 'react';
import { FlexContainer } from '@taxdown/piccolo-web';
import TrashIcon from 'Components/icons/TrashIcon';
import SummaryCardBody from '../SummaryCardBody';
import { SummaryCardProps, defaultProps } from './types';
import { SummaryCardHeader } from './components';
import * as Styled from './styles';

const SummaryCard: React.FC<SummaryCardProps> = ({
  summaryCard,
  deleteCard,
  editCard,
  summaryCardGroup,
}) => {
  const yayoyakis = summaryCard.getYayoyakis();
  const { header, subheader, additionalIcon, icon } = summaryCard.getRenderForm();
  const { messages, isValid } = summaryCard.getValidationError();
  const isReadOnly = summaryCardGroup.isReadOnly();
  return (
    <FlexContainer direction="column">
      <Styled.SummaryCardContainer data-testid="summaryCard" readOnly={isReadOnly}>
        {!isReadOnly && (
          <Styled.TrushArea onClick={() => deleteCard(summaryCard)} data-testid="deleteButton">
            <TrashIcon />
          </Styled.TrushArea>
        )}
        <Styled.CardContent>
          <FlexContainer>
            <Styled.SummaryIcon hasIcon={icon}>
              {icon && <img src={icon} alt="card-icon" />}
            </Styled.SummaryIcon>
            <Styled.StyledContainer direction="column" fullWidth>
              <SummaryCardHeader
                header={header}
                subheader={subheader}
                additionalIcon={additionalIcon}
                handleOnEdit={e => editCard(e, summaryCard)}
              />
              {yayoyakis?.length > 0 && <SummaryCardBody yayoyakis={yayoyakis} />}
            </Styled.StyledContainer>
          </FlexContainer>
          {!isValid && <Styled.InvalidBox errors={messages} />}
        </Styled.CardContent>
      </Styled.SummaryCardContainer>
    </FlexContainer>
  );
};

SummaryCard.defaultProps = defaultProps;

export default SummaryCard;
